/* Organize the existing editor without changing its rendering/export engine. */
(() => {
  const panel = document.querySelector('.panel');
  const form = document.querySelector('#controls');
  if (!panel || !form) return;
  panel.classList.add('studio-redesigned');
  const header = panel.querySelector('.panel-head');
  const save = document.querySelector('#download');
  const size = document.querySelector('#exportSize');
  const sizeLabel = size.closest('label');
  sizeLabel.hidden = true;
  size.value = '3300';
  const saveControls = document.createElement('div');
  saveControls.className = 'save-controls';
  saveControls.append(save);
  header.append(saveControls);
  const random = document.querySelector('#randomShow');
  const quickActions=document.createElement('div');quickActions.className='quick-actions';quickActions.setAttribute('role','group');quickActions.setAttribute('aria-label','Try a random show or scene');quickActions.append(random,document.querySelector('#randomScene'));const editorToolbar=document.createElement('div');editorToolbar.className='editor-toolbar';editorToolbar.append(quickActions);const shareActions=panel.querySelector('.maker-share');if(shareActions)editorToolbar.append(shareActions);header.after(editorToolbar);
  panel.querySelector('.actions').hidden = true;

  const appearance = document.createElement('section');
  appearance.className = 'appearance';
  appearance.setAttribute('aria-label', 'Appearance');
  const appearanceHeading = document.createElement('div');
  appearanceHeading.className = 'appearance-heading';
  const title = document.createElement('span');
  title.textContent = 'Appearance';
  const appearanceToggles=document.createElement('div');
  appearanceToggles.className='appearance-toggles';
  appearanceToggles.append(document.querySelector('.paper-folds'));
  appearanceHeading.append(title, appearanceToggles);
  const appearanceFields = document.createElement('div');
  appearanceFields.className = 'appearance-fields';
  for (const [id, text] of [['scenePicker', 'Scene'], ['mountPicker', 'Mount']]) {
    const label = document.createElement('label');
    label.textContent = text;
    if(id==='scenePicker'){
      const sceneControls=document.createElement('div');sceneControls.className='scene-choice-controls';
      sceneControls.append(document.getElementById(id));
      label.append(sceneControls);
    }else label.append(document.getElementById(id));
    appearanceFields.append(label);
  }
  appearanceFields.append(form.querySelector('.paper-colors'));
  appearance.append(appearanceHeading, appearanceFields);
  form.append(appearance);

  const rename = (name, text, placeholder) => {
    const input = form.elements[name];
    input.closest('label').firstChild.textContent = text + '\n';
    if (placeholder) input.placeholder = placeholder;
  };
  rename('topline', 'Intro line', 'e.g. Special engagement');
  rename('guestLabel', 'Support heading', 'e.g. With special guests');
  rename('supportAct', 'Supporting act', 'e.g. Opening band');
  rename('agesLine', 'Ages', 'e.g. All ages welcome');
  rename('doorsLine', 'Doors', 'e.g. Doors open 7:00 PM');
  rename('showLine', 'Show time', 'e.g. Show starts 8:00 PM');
  rename('venueLine', 'Venue');
  rename('addressLine', 'Address');
  rename('noteLine', 'Ticket information', 'e.g. Advance $10 / day of show $12');
  for (const name of ['headlineOne', 'headlineTwo', 'headlineThree']) {
    form.elements[name].placeholder = 'Band name or title';
  }

  const footerInputs = ['tinyLineOne', 'tinyLineTwo', 'tinyLineThree'].map(name => form.elements[name]);
  for (const input of footerInputs) input.closest('label').hidden = true;
  const footerLabel = document.createElement('label');
  footerLabel.className = 'footer-editor';
  footerLabel.textContent = 'Footer text';
  const footer = document.createElement('textarea');
  footer.id = 'footerText';
  footer.rows = 3;
  footer.setAttribute('aria-label', 'Footer text, up to three lines');
  footer.placeholder = 'Ticket outlets, box-office information, or other fine print';
  const footerHelp = document.createElement('small');
  footerHelp.textContent = 'Up to three lines on the flyer.';
  footerLabel.append(footer, footerHelp);
  form.querySelector('.details-fields').append(footerLabel);
  footer.addEventListener('input', () => {
    const lines = footer.value.split('\n');
    footerInputs.forEach((input, index) => {
      input.value = index === 2 ? lines.slice(2).join(' ') : (lines[index] || '');
    });
  });

  const bandNames = ['headlineOne', 'headlineTwo', 'headlineThree'];
  const revealed = new Set();
  const addBand = document.createElement('button');
  addBand.type = 'button';
  addBand.className = 'add-band';
  addBand.textContent = '+ Add another band line';
  form.elements.headlineThree.closest('label').nextElementSibling.after(addBand);
  const tools = bandNames.map(name => {
    const input = form.elements[name];
    const label = input.closest('label');
    label.classList.add('band-editor');
    const row = label.nextElementSibling;
    row.classList.add('band-sizing');
    const buttons = row.querySelectorAll('button');
    buttons[0].textContent = 'A−';
    buttons[1].textContent = '↺';
    buttons[1].title = 'Reset text size';
    buttons[2].textContent = 'A+';
    row.append(buttons[1]);
    return {input, label, row};
  });
  function sync() {
    for (const {input, label, row} of tools) {
      const empty = !input.value.trim();
      label.hidden = false;
      row.hidden = false; row.querySelectorAll("button").forEach(button=>button.disabled=empty);
    }
    addBand.hidden = tools.slice(1).every(({label}) => !label.hidden);
    if (document.activeElement !== footer) {
      footer.value = footerInputs.map(input => input.value).join('\n').trimEnd();
    }
  }
  addBand.addEventListener('click', () => {
    const next = tools.slice(1).find(({label}) => label.hidden);
    if (!next) return;
    revealed.add(next.input.name);
    sync();
    next.input.focus();
  });
  form.addEventListener('input', sync);
  for (const element of [random, document.querySelector('#showPicker')]) {
    element.addEventListener(element === random ? 'click' : 'change', () => { revealed.clear(); sync(); });
  }
  new MutationObserver(sync).observe(document.querySelector('.poster-copy'), {subtree: true, childList: true});
  sync();

  // Use actual tab semantics for the two editing views.
  const tabs = panel.querySelector('.editor-sections');
  form.prepend(appearance, tabs);
  form.elements.topline.closest('label').after(form.elements.dateLine.closest('label'));
  tabs.setAttribute('role', 'tablist');
  const tabButtons = [...tabs.querySelectorAll('button')];
  for (const button of tabButtons) {
    button.setAttribute('role', 'tab');
    const updateTab = () => {
      const active = button.getAttribute('aria-pressed') === 'true';
      button.setAttribute('aria-selected', String(active));
      button.tabIndex = active ? 0 : -1;
    };
    new MutationObserver(updateTab).observe(button, {attributes: true, attributeFilter: ['aria-pressed']});
    updateTab();
    button.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const target = event.key === 'Home' ? tabButtons[0] : event.key === 'End' ? tabButtons.at(-1) : tabButtons.find(item => item !== button);
      target.click(); target.focus();
    });
  }


  // Keep secondary actions available without separate permanent toolbars.
  panel.classList.add("flyer-compact");
  panel.querySelector(".show-choose-row").append(random);
  panel.querySelector(".scene-choice-controls").append(document.querySelector("#randomScene"));
  document.querySelector("#randomScene").textContent="Random";
  const share=panel.querySelector(".maker-share");
  if(share){const menu=document.createElement("details"),summary=document.createElement("summary");menu.className="share-menu";summary.textContent="Share";menu.append(summary,share);saveControls.prepend(menu)}
  editorToolbar.remove();
  const detailsFields=form.querySelector(".details-fields");
  for(const name of ["guestLabel","topline"])detailsFields.prepend(form.elements[name].closest("label"));
  const date=form.elements.dateLine.closest("label");addBand.after(date);
  form.elements.supportAct.closest("label").classList.add("primary-support");
  const draft=panel.querySelector("#draftStatus");if(draft)draft.classList.add("sr-only");
  // Editing views size naturally; only the optional details list has a bounded height.
  form.style.removeProperty("--main-form-height");form.style.removeProperty("--fixed-form-height");form.style.removeProperty("--details-space");
})();

// Cycle the existing validated choices through their original change handlers.
(()=>{
 const panel=document.querySelector('.panel');if(!panel)return;
 const status=document.createElement('span');status.className='sr-only';status.setAttribute('role','status');panel.append(status);
 const controls=[];
 for(const [id,label] of [['scenePicker','Scene'],['mountPicker','Mount']]){
  const select=document.getElementById(id);if(!select)continue;
  const button=document.createElement('button');button.type='button';button.id=id+'Cycle';button.className='cycle-choice';button.title='Click for the next '+label.toLowerCase();
  select.hidden=true;select.after(button);
  const wrapper=select.closest('label');wrapper.classList.add('cycle-choice-label');if(wrapper.firstChild.nodeType===Node.TEXT_NODE)wrapper.firstChild.textContent='';
  function refresh(){const option=select.selectedOptions[0];button.textContent=label+': '+(option?option.textContent:'None')+' →';button.disabled=[...select.options].filter(option=>!option.disabled).length<2}
  button.addEventListener('click',()=>{const options=[...select.options].filter(option=>!option.disabled);if(options.length<2)return;const index=options.findIndex(option=>option.value===select.value);select.value=options[(index+1)%options.length].value;select.dispatchEvent(new Event('change',{bubbles:true}));controls.forEach(control=>control());status.textContent=button.textContent.replace(' →','')});
  select.addEventListener('change',refresh);new MutationObserver(refresh).observe(select,{childList:true,subtree:true});controls.push(refresh);refresh();
 }
 const refresh=()=>queueMicrotask(()=>controls.forEach(control=>control()));
 new MutationObserver(refresh).observe(document.body,{attributes:true,attributeFilter:['data-wall','data-hands']});
 new MutationObserver(refresh).observe(document.querySelector('.poster-wrap'),{attributes:true,attributeFilter:['data-mount']});
 const random=document.getElementById('randomScene');if(random)random.hidden=true;
})();

// Align the everyday text fields without changing the editing engine.
(()=>{
 const panel=document.querySelector('.panel'),form=document.querySelector('#controls');if(!panel||!form)return;
 panel.classList.add('flyer-polished');
 const fields=document.createElement('div');fields.className='primary-fields';
 fields.append(form.elements.dateLine.closest('label'),form.elements.supportAct.closest('label'));form.append(fields);
})();
